<template>
  <div>
    <div class="filter-bar">
      <span @click="selectYear">
        年份 {{ year }}
        <i class="caret"></i>
      </span>
      <span>
        {{ querytype }}
        <i class="caret"></i>
        <select
          class="filter-item__select"
          v-model="querytype"
          @change="searchMonth"
        >
          <option :value="'全部'">全部</option>
          <option :value="'物料'">物料</option>
          <option :value="'物料类型'">物料类型</option>
          <option :value="'客户'">客户</option>
          <option :value="'客户类型'">客户类型</option>
          <option :value="'部门'">部门</option>
          <option :value="'业务员'">业务员</option>
          <option :value="'厂家/品牌'">厂家/品牌</option>
        </select>
      </span>
    </div>
    <div class="canvas-box" v-show="result.monthitems">
      <canvas id="myChart" class="myChart"></canvas>
    </div>

    <div class="list-box">
      <div class="list-left">
        <div class="list-cell">
          <div class="list-cell__main height-36">
            <div class="list-cell__index"></div>
            <div class="list-cell__toggle text-header">本年出货合计</div>
            <div class="list-cell__toggle text-header">本年退货合计</div>
          </div>
        </div>
        <div class="list-cell" v-for="(item, index) in list" :key="index">
          <div
            class="list-cell__main"
            :class="selected == index + 1 ? 'bg-color' : ''"
            @click="open(item, index + 1)"
          >
            <div class="list-cell__index">
              <span>{{ index + 1 }}</span>
            </div>
            <div class="list-cell__content">
              {{ item.outtotal }}
            </div>
            <div class="list-cell__content">
              {{ item.intotal }}
            </div>
          </div>
        </div>
      </div>
      <div class="list-right">
        <div class="list-cell" :class="getClassName()">
          <div class="list-cell__main">
            <div class="list-cell__100 text-header">本年退货率%</div>
            <div class="list-cell__100 text-header" v-if="querytype == '物料'">
              物料编号
            </div>
            <div class="list-cell__100 text-header" v-if="querytype == '物料'">
              物料名称
            </div>
            <div class="list-cell__100 text-header" v-if="querytype == '物料'">
              型号
            </div>
            <div
              class="list-cell__100 text-header"
              v-if="querytype == '物料类型'"
            >
              物料类型
            </div>
            <div class="list-cell__100 text-header" v-if="querytype == '客户'">
              客户编号
            </div>
            <div class="list-cell__100 text-header" v-if="querytype == '客户'">
              客户名称
            </div>
            <div
              class="list-cell__100 text-header"
              v-if="querytype == '客户类型'"
            >
              客户类型
            </div>
            <div class="list-cell__100 text-header" v-if="querytype == '部门'">
              部门
            </div>
            <div
              class="list-cell__100 text-header"
              v-if="querytype == '业务员'"
            >
              业务员号
            </div>
            <div
              class="list-cell__100 text-header"
              v-if="querytype == '业务员'"
            >
              业务员
            </div>
            <div
              class="list-cell__100 text-header"
              v-if="querytype == '厂家/品牌'"
            >
              厂家/品牌
            </div>
            <div class="text-two-header">
              <div class="width-200">1月</div>
              <div class="width-200">
                <span class="small-header">出货数量</span>
                <span class="small-header">退货数量</span>
                <span class="small-header">退货率%</span>
              </div>
            </div>
            <div class="text-two-header">
              <div class="width-200">2月</div>
              <div class="width-200">
                <span class="small-header">出货数量</span>
                <span class="small-header">退货数量</span>
                <span class="small-header">退货率%</span>
              </div>
            </div>
            <div class="text-two-header">
              <div class="width-200">3月</div>
              <div class="width-200">
                <span class="small-header">出货数量</span>
                <span class="small-header">退货数量</span>
                <span class="small-header">退货率%</span>
              </div>
            </div>
            <div class="text-two-header">
              <div class="width-200">4月</div>
              <div class="width-200">
                <span class="small-header">出货数量</span>
                <span class="small-header">退货数量</span>
                <span class="small-header">退货率%</span>
              </div>
            </div>
            <div class="text-two-header">
              <div class="width-200">5月</div>
              <div class="width-200">
                <span class="small-header">出货数量</span>
                <span class="small-header">退货数量</span>
                <span class="small-header">退货率%</span>
              </div>
            </div>
            <div class="text-two-header">
              <div class="width-200">6月</div>
              <div class="width-200">
                <span class="small-header">出货数量</span>
                <span class="small-header">退货数量</span>
                <span class="small-header">退货率%</span>
              </div>
            </div>
            <div class="text-two-header">
              <div class="width-200">7月</div>
              <div class="width-200">
                <span class="small-header">出货数量</span>
                <span class="small-header">退货数量</span>
                <span class="small-header">退货率%</span>
              </div>
            </div>
            <div class="text-two-header">
              <div class="width-200">8月</div>
              <div class="width-200">
                <span class="small-header">出货数量</span>
                <span class="small-header">退货数量</span>
                <span class="small-header">退货率%</span>
              </div>
            </div>
            <div class="text-two-header">
              <div class="width-200">9月</div>
              <div class="width-200">
                <span class="small-header">出货数量</span>
                <span class="small-header">退货数量</span>
                <span class="small-header">退货率%</span>
              </div>
            </div>
            <div class="text-two-header">
              <div class="width-200">10月</div>
              <div class="width-200">
                <span class="small-header">出货数量</span>
                <span class="small-header">退货数量</span>
                <span class="small-header">退货率%</span>
              </div>
            </div>
            <div class="text-two-header">
              <div class="width-200">11月</div>
              <div class="width-200">
                <span class="small-header">出货数量</span>
                <span class="small-header">退货数量</span>
                <span class="small-header">退货率%</span>
              </div>
            </div>
            <div class="text-two-header">
              <div class="width-200">12月</div>
              <div class="width-200">
                <span class="small-header">出货数量</span>
                <span class="small-header">退货数量</span>
                <span class="small-header">退货率%</span>
              </div>
            </div>
          </div>
          <div
            class="list-cell"
            :class="getClassName()"
            v-for="(items, index2) in list"
            :key="index2"
          >
            <div
              class="list-cell__main"
              :class="selected == index2 + 1 ? 'bg-color' : ''"
              @click="open(items, index2 + 1)"
            >
              <div class="list-cell__150">
                {{ items.returnrate }}
              </div>
              <div class="list-cell__150" v-if="querytype == '物料'">
                {{ items.pr_code }}
              </div>
              <div class="list-cell__150" v-if="querytype == '物料'">
                {{ items.pr_detail }}
              </div>
              <div class="list-cell__150" v-if="querytype == '物料'">
                {{ items.pr_orispeccode }}
              </div>
              <div class="list-cell__150" v-if="querytype == '物料类型'">
                {{ items.pr_kind }}
              </div>
              <div class="list-cell__150" v-if="querytype == '客户'">
                {{ items.pi_custcode }}
              </div>
              <div class="list-cell__150" v-if="querytype == '客户'">
                {{ items.pi_custname }}
              </div>
              <div class="list-cell__150" v-if="querytype == '客户类型'">
                {{ items.cu_type }}
              </div>
              <div class="list-cell__150" v-if="querytype == '部门'">
                {{ items.dp_name }}
              </div>
              <div class="list-cell__150" v-if="querytype == '业务员'">
                {{ items.pi_sellercode }}
              </div>
              <div class="list-cell__150" v-if="querytype == '业务员'">
                {{ items.pi_seller }}
              </div>
              <div class="list-cell__150" v-if="querytype == '厂家/品牌'">
                {{ items.pr_brand }}
              </div>
              <div class="list-cell__toggle color-blue">
                <span v-if="items.outqty1" v-format="'#,##0.00'">{{
                  items.outqty1
                }}</span>
                <span v-else>0</span>
              </div>
              <div class="list-cell__toggle color-green">
                <span v-if="items.inqty1" v-format="'#,##0.00'">{{
                  items.inqty1
                }}</span>
                <span v-else>0</span>
              </div>
              <div class="list-cell__toggle color-red">
                {{ items.returnrate1 || 0 }}
              </div>
              <div class="list-cell__toggle color-blue">
                <span v-if="items.outqty2" v-format="'#,##0.00'">{{
                  items.outqty2
                }}</span>
                <span v-else>0</span>
              </div>
              <div class="list-cell__toggle color-green">
                <span v-if="items.inqty2" v-format="'#,##0.00'">{{
                  items.inqty2
                }}</span>
                <span v-else>0</span>
              </div>
              <div class="list-cell__toggle color-red">
                {{ items.returnrate2 || 0 }}
              </div>
              <div class="list-cell__toggle color-blue">
                <span v-if="items.outqty3" v-format="'#,##0.00'">{{
                  items.outqty3
                }}</span>
                <span v-else>0</span>
              </div>
              <div class="list-cell__toggle color-green">
                <span v-if="items.inqty3" v-format="'#,##0.00'">{{
                  items.inqty3
                }}</span>
                <span v-else>0</span>
              </div>
              <div class="list-cell__toggle color-red">
                {{ items.returnrate3 || 0 }}
              </div>
              <div class="list-cell__toggle color-blue">
                <span v-if="items.outqty4" v-format="'#,##0.00'">{{
                  items.outqty4
                }}</span>
                <span v-else>0</span>
              </div>
              <div class="list-cell__toggle color-green">
                <span v-if="items.inqty4" v-format="'#,##0.00'">{{
                  items.inqty4
                }}</span>
                <span v-else>0</span>
              </div>
              <div class="list-cell__toggle color-red">
                {{ items.returnrate4 || 0 }}
              </div>
              <div class="list-cell__toggle color-blue">
                <span v-if="items.outqty5" v-format="'#,##0.00'">{{
                  items.outqty5
                }}</span>
                <span v-else>0</span>
              </div>
              <div class="list-cell__toggle color-green">
                <span v-if="items.inqty5" v-format="'#,##0.00'">{{
                  items.inqty5
                }}</span>
                <span v-else>0</span>
              </div>
              <div class="list-cell__toggle color-red">
                {{ items.returnrate5 || 0 }}
              </div>
              <div class="list-cell__toggle color-blue">
                <span v-if="items.outqty6" v-format="'#,##0.00'">{{
                  items.outqty6
                }}</span>
                <span v-else>0</span>
              </div>
              <div class="list-cell__toggle color-green">
                <span v-if="items.inqty6" v-format="'#,##0.00'">{{
                  items.inqty6
                }}</span>
                <span v-else>0</span>
              </div>
              <div class="list-cell__toggle color-red">
                {{ items.returnrate6 || 0 }}
              </div>
              <div class="list-cell__toggle color-blue">
                <span v-if="items.outqty7" v-format="'#,##0.00'">{{
                  items.outqty7
                }}</span>
                <span v-else>0</span>
              </div>
              <div class="list-cell__toggle color-green">
                <span v-if="items.inqty7" v-format="'#,##0.00'">{{
                  items.inqty7
                }}</span>
                <span v-else>0</span>
              </div>
              <div class="list-cell__toggle color-red">
                {{ items.returnrate7 || 0 }}
              </div>
              <div class="list-cell__toggle color-blue">
                <span v-if="items.outqty8" v-format="'#,##0.00'">{{
                  items.outqty8
                }}</span>
                <span v-else>0</span>
              </div>
              <div class="list-cell__toggle color-green">
                <span v-if="items.inqty8" v-format="'#,##0.00'">{{
                  items.inqty8
                }}</span>
                <span v-else>0</span>
              </div>
              <div class="list-cell__toggle color-red">
                {{ items.returnrate8 || 0 }}
              </div>
              <div class="list-cell__toggle color-blue">
                <span v-if="items.outqty9" v-format="'#,##0.00'">{{
                  items.outqty9
                }}</span>
                <span v-else>0</span>
              </div>
              <div class="list-cell__toggle color-green">
                <span v-if="items.inqty9" v-format="'#,##0.00'">{{
                  items.inqty9
                }}</span>
                <span v-else>0</span>
              </div>
              <div class="list-cell__toggle color-red">
                {{ items.returnrate9 || 0 }}
              </div>
              <div class="list-cell__toggle color-blue">
                <span v-if="items.outqty10" v-format="'#,##0.00'">{{
                  items.outqty10
                }}</span>
                <span v-else>0</span>
              </div>
              <div class="list-cell__toggle color-green">
                <span v-if="items.inqty10" v-format="'#,##0.00'">{{
                  items.inqty10
                }}</span>
                <span v-else>0</span>
              </div>
              <div class="list-cell__toggle color-red">
                {{ items.returnrate10 || 0 }}
              </div>
              <div class="list-cell__toggle color-blue">
                <span v-if="items.outqty11" v-format="'#,##0.00'">{{
                  items.outqty11
                }}</span>
                <span v-else>0</span>
              </div>
              <div class="list-cell__toggle color-green">
                <span v-if="items.inqty11" v-format="'#,##0.00'">{{
                  items.inqty11
                }}</span>
                <span v-else>0</span>
              </div>
              <div class="list-cell__toggle color-red">
                {{ items.returnrate11 || 0 }}
              </div>
              <div class="list-cell__toggle color-blue">
                <span v-if="items.outqty12" v-format="'#,##0.00'">{{
                  items.outqty12
                }}</span>
                <span v-else>0</span>
              </div>
              <div class="list-cell__toggle color-green">
                <span v-if="items.inqty12" v-format="'#,##0.00'">{{
                  items.inqty12
                }}</span>
                <span v-else>0</span>
              </div>
              <div class="list-cell__toggle color-red">
                {{ items.returnrate12 || 0 }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import F2 from '@antv/f2'
import F2 from "@antv/f2/lib/index";
import ScrollBar from "@antv/f2/lib/plugin/scroll-bar";
import "@antv/f2/lib/interaction/pan";

export default {
  data() {
    let year = new Date().getFullYear();

    return {
      result: {},
      year,
      querytype: "全部",
      querytypeObj: {
        全部: "detail",
        物料: "prod",
        物料类型: "prkind",
        客户: "cust",
        客户类型: "custtype",
        部门: "dept",
        业务员: "seller",
        "厂家/品牌": "brand",
      },
      list: [],
      selected: -1,
      chart: null,
    };
  },
  mounted() {
    this.searchMonth();
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
    if (this.chart) {
      this.chart.destroy();
    }
  },
  methods: {
    getClassName() {
      let me = this,
        className = "width-all";
      if (me.querytype == "全部") {
        className = "width-all";
      } else if (me.querytype == "物料") {
        className = "width-product";
      } else if (
        me.querytype == "物料类型" ||
        me.querytype == "客户类型" ||
        me.querytype == "部门" ||
        me.querytype == "厂家/品牌"
      ) {
        className = "width-type";
      } else if (me.querytype == "客户" || me.querytype == "业务员") {
        className = "width-customer";
      }
      return className;
    },
    searchMonth() {
      let me = this;
      me.selected = -1;
      let querytype = me.querytypeObj[me.querytype];

      let params = {
        year: me.year,
        querytype,
      };

      me.$ajax({
        url: "/api/storage/report/saleInMonth",
        params,
      }).then(function (res) {
        if (res.success) {
          me.result = res.data;
          me.initChart(me.deal(me.result.monthitems));
          me.list = res.data.details;
        }
      });
    },
    onResize() {
      var chart = this.chart;
      if (chart) {
        this.chart = chart.destroy();
        this.initChart(this.deal(this.result.monthitems));
      }
    },
    initChart(data) {
      var chart = this.chart;
      if (chart) {
        chart.changeData(data);
        return;
      }
      this.chart = chart = new F2.Chart({
        id: "myChart",
        width: window.innerWidth,
        height: Math.min(window.innerHeight * 0.6, 300),
        pixelRatio: window.devicePixelRatio,
        plugins: ScrollBar,
      });

      chart.source(data, {
        index: {
          type: "linear",
          tickInterval: 1,
          min: -1,
          max: window.innerWidth > window.innerHeight ? 12 : 6,
          formatter: (i) =>
            i > -1 && i < 12
              ? [
                  "01月",
                  "02月",
                  "03月",
                  "04月",
                  "05月",
                  "06月",
                  "07月",
                  "08月",
                  "09月",
                  "10月",
                  "11月",
                  "12月",
                ][i]
              : null,
        },
      });

      chart
        .interval()
        .position("index*value")
        .color("type", (val) => {
          if (val === "出货数量") {
            return "#2eadf5";
          } else if (val === "退货数量") {
            return "#e44959";
          }
        })
        .adjust({
          type: "dodge",
          marginRatio: 0.05, // 设置分组间柱子的间距
        });
      if (window.innerWidth < window.innerHeight) {
        // 定义进度条
        chart.scrollBar({
          mode: "x",
          xStyle: {
            backgroundColor: "#e8e8e8",
            fillerColor: "#808080",
            offsetY: -2,
          },
        });
      }
      chart.interaction("pan");
      chart.render();
    },
    deal(data) {
      if (!data) return;

      const textArr = [
        "01月",
        "02月",
        "03月",
        "04月",
        "05月",
        "06月",
        "07月",
        "08月",
        "09月",
        "10月",
        "11月",
        "12月",
      ];

      let arr = [
        { index: -1, type: "出货数量", value: 0 },
        { index: 12, type: "出货数量", value: 0 },
      ];
      for (let i = 0; i < 12; i++) {
        arr.push(
          {
            text: textArr[i],
            type: "出货数量",
            index: i,
            value: data[i]?.outqty || 0,
          },
          {
            text: textArr[i],
            type: "退货数量",
            index: i,
            value: data[i]?.inqty || 0,
          }
        );
      }
      return arr;
    },
    deal1(data) {
      if (!data) return;
      const textArr = [
        "01月",
        "02月",
        "03月",
        "04月",
        "05月",
        "06月",
        "07月",
        "08月",
        "09月",
        "10月",
        "11月",
        "12月",
      ];

      let arr = [
        { index: -1, type: "退货数量", value: 0 },
        { index: 12, type: "退货数量", value: 0 },
      ];
      for (let i = 0; i < 12; i++) {
        arr.push(
          {
            index: i,
            text: textArr[i],
            type: "退货数量",
            value: data["inqty" + (i + 1)] || 0,
          },
          {
            index: i,
            text: textArr[i],
            type: "出货数量",
            value: data["outqty" + (i + 1)] || 0,
          }
        );
      }
      return arr;
    },
    open(data, index) {
      let me = this,
        list = [];
      list = data;
      me.selected = index;
      me.initChart(me.deal1(list));
    },
    selectYear() {
      var me = this,
        year = new Date().getFullYear(),
        years = [];
      for (let i = year - 20; i <= year; i++) {
        years.push({
          value: i,
          label: i + "年",
        });
      }
      me.$weui.picker(years, {
        title: "选择年份",
        defaultValue: [year],
        onConfirm: function (r) {
          me.year = r[0].value;
          me.searchMonth();
        },
      });
    },
    getMonth(month) {
      return month < 10 ? "0" + month : month;
    },
  },
};
</script>

<style scoped>
.bg-color {
  background: #fabcc1;
}
.color-green {
  color: #2bb72e;
}
.color-red {
  color: #e44959;
}
.color-blue {
  color: #2eadf5;
}
.filter-bar {
  width: 100%;
  background: var(--weui-BG-2);
  box-sizing: border-box;
  text-align: center;
  font-size: 13px;
  padding: 11px 0 9px 0;
  color: #9b9b9b;
  margin-bottom: 1px;
  display: flex;
}
.filter-bar span {
  margin: 0 auto;
  flex: 1;
  position: relative;
}
.filter-item__select {
  position: absolute;
  margin: 0;
  padding: 0;
  border: 0;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}
.filter-item__select option {
  color: var(--weui-FG-0);
  background: var(--weui-BG-2);
}
.nav {
  padding: 10px 20px;
  display: flex;
  justify-content: space-around;
  background: var(--weui-BG);
}
.nav .selected {
  color: #38559f;
}
.canvas-title {
  padding-top: 10px;
  font-size: 12px;
  font-weight: bold;
  width: 100%;
  text-align: center;
  background: var(--weui-BG);
}
.canvas-box {
  /* width: 100%;
  height: 100%; */
  background: var(--weui-BG);
}

.list-box {
  margin-top: 5px;
  background: var(--weui-BG);
  display: flex;
}
.list-left {
  width: 180px;
  display: flex;
  flex-direction: column;
}
.list-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-x: scroll;
}
.report-item {
  width: calc(100% - 20px);
  height: 30px;
  margin: 0 auto;
  font-size: 13px;
  border-bottom: 1px solid #cccccc;
  line-height: 30px;
  color: var(--weui-FG-0);
  display: flex;
}
.font-bold {
  font-weight: bold;
}
.report-item .report-item-name {
  flex: 2;
  text-align: left;
  padding: 0 2px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.report-item .report-item-year {
  flex: 1;
  text-align: center;
  padding: 0 2px;
}
.report-item .report-item-month {
  flex: 1;
  text-align: center;
  padding: 0 2px;
}

.list-cell {
  background-color: #fff;
  border-top: 1px solid #cccccc;
  border-right: 1px solid #cccccc;
}
.list-left > .list-cell {
  border-left: 1px solid #cccccc;
}
.width-all {
  width: 2518px;
}
.width-customer {
  width: 2730px;
}
.width-type {
  width: 2630px;
}
.width-product {
  width: 2810px;
}
.list-cell__main {
  display: flex;
  /* width: 100%; */
  /* flex-direction: row;
  justify-content: center;
  align-items: center; */
  padding: 10px 0;
}
.height-36 {
  height: 36px !important;
}
.list-cell__index {
  width: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.list-cell__index span {
  border-radius: 50%;
  width: 20px;
  height: 20px;
  color: #fff;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  background-color: #c0c0c0;
}
.list-cell__content {
  width: 144px;
  height: 36px;
  line-height: 36px;
  font-size: 12px;
  text-align: center;
  color: #000;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.list-cell__150 {
  width: 150px;
  height: 36px;
  line-height: 36px;
  font-size: 12px;
  color: #000;
  text-align: center;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.list-cell__100 {
  width: 100px;
  height: 36px;
  line-height: 36px;
  font-size: 12px;
  color: #000;
  text-align: center;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.list-cell__toggle {
  width: 100px;
  height: 36px;
  text-align: center;
  line-height: 36px;
  font-size: 12px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.text-header {
  font-weight: bold;
  color: #000 !important;
}

.text-two-header {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  text-align: center;
}
.width-400 {
  width: 400px;
}
.width-200 {
  width: 200px;
}
.text-two-header > div {
  height: 18px;
  font-size: 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  border-left: 1px dashed #8b8b8b;
}

.small-header {
  display: inline-block;
  width: 84px;
  height: 18px;
  text-align: center;
  font-size: 12px !important;
  font-weight: bold;
}
.gray {
  /* max-height: 300px;
  overflow-y: auto; */
  background: #f4f4f4;
}
@media screen and (min-width: 500px) {
  .filter-bar {
    padding: 6px 0 2px 0;
  }
  .list-cell__toggle {
    height: 20px;
    line-height: 20px;
  }
  .list-cell__content {
    height: 20px;
    line-height: 20px;
  }
  .list-cell__index span {
    width: 20px;
    height: 20px;
  }
  .list-cell__main {
    padding: 5px 0px;
  }
  .list-cell__150 {
    padding: 0px 0px;
    height: 20px;
    line-height: 20px;
  }
}
</style>